import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionRoomOverSiteControllerPeopleNum } from "./over-site-controller-people-num/root";

import type { StandardRoomCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	advancedPricing: StandardRoomCategoriesAndManagerStore["advancedPricing"];
};

export const QuestionRoomAdvancedPricing = ({ advancedPricing }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={advancedPricing}>
			<QuestionRoomOverSiteControllerPeopleNum />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionRoomAdvancedPricing.displayName = "QuestionRoomAdvancedPricing";
